export default __webpack_public_path__ + "static/media/COIN-BIG-SILVER.9909f083.png";